import QualityImg from '@/components/qualityImg/qualityImg.vue'
export default {
    name: 'serviceCard',
    data () {
        return {}
    },
    components: {
        QualityImg
    },
    props: {
        service: {
            type: Object,
            default: {}
        }
    },
    created () {},
    activated () {},
    mounted () {}
}
